import React, { useState } from 'react';
import styles from './JsonTree.module.css';

function JsonNode({ value, depth = 0 }) {
  const [open, setOpen] = useState(depth < 2);

  if (value === null) return <span className={styles.null}>null</span>;
  if (typeof value === 'boolean') return <span className={styles.bool}>{String(value)}</span>;
  if (typeof value === 'number') return <span className={styles.num}>{value}</span>;
  if (typeof value === 'string') return <span className={styles.str}>"{value}"</span>;

  if (Array.isArray(value)) {
    if (value.length === 0) return <span className={styles.punct}>[]</span>;
    return (
      <span>
        <button className={styles.toggle} onClick={() => setOpen(o => !o)} type="button">
          {open ? '▾' : '▸'}
        </button>
        {open ? (
          <span>
            <span className={styles.punct}>{'['}</span>
            <div className={styles.indent}>
              {value.map((v, i) => (
                <div key={i}>
                  <JsonNode value={v} depth={depth + 1} />
                  {i < value.length - 1 && <span className={styles.punct}>,</span>}
                </div>
              ))}
            </div>
            <span className={styles.punct}>{']'}</span>
          </span>
        ) : (
          <span className={styles.collapsed}>[{value.length} items]</span>
        )}
      </span>
    );
  }

  if (typeof value === 'object') {
    const keys = Object.keys(value);
    if (keys.length === 0) return <span className={styles.punct}>{'{}'}</span>;
    return (
      <span>
        <button className={styles.toggle} onClick={() => setOpen(o => !o)} type="button">
          {open ? '▾' : '▸'}
        </button>
        {open ? (
          <span>
            <span className={styles.punct}>{'{'}</span>
            <div className={styles.indent}>
              {keys.map((k, i) => (
                <div key={k}>
                  <span className={styles.key}>"{k}"</span>
                  <span className={styles.punct}>: </span>
                  <JsonNode value={value[k]} depth={depth + 1} />
                  {i < keys.length - 1 && <span className={styles.punct}>,</span>}
                </div>
              ))}
            </div>
            <span className={styles.punct}>{'}'}</span>
          </span>
        ) : (
          <span className={styles.collapsed}>{'{'}…{'}'}</span>
        )}
      </span>
    );
  }

  return <span>{String(value)}</span>;
}

export default function JsonTree({ data, maxHeight = 260 }) {
  if (data === null || data === undefined) {
    return <span className={styles.null}>null</span>;
  }
  return (
    <div className={styles.root} style={{ maxHeight }}>
      <JsonNode value={data} depth={0} />
    </div>
  );
}
